import { render, staticRenderFns } from "./LeaveDocumentModal.vue?vue&type=template&id=06aa260a"
import script from "./LeaveDocumentModal.vue?vue&type=script&lang=js"
export * from "./LeaveDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports